import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';

const defaultSortCaret = (order) => (
  <span className="order">
    <span className={`caret caret-up${order === 'asc' ? ' active' : ''}`} />
    <span className={`caret caret-down${order === 'desc' ? ' active' : ''}`} />
  </span>
);

export const ConversationDataTable = ({
  data = [],
  columns = [],
  onTableChange,
  defaultSorted,
  sort,
  noDataIndication = 'No data found',
  tableKey = 'default',
  expandRow,
  rowEvents,
  rowClasses = 'table-row',
}) => (
  <BootstrapTable
    key={tableKey}
    hover
    striped
    keyField="_id"
    noDataIndication={noDataIndication}
    data={data}
    columns={columns.map((column) => ({
      ...column,
      sort: typeof column.sort === 'undefined' ? true : column.sort,
      sortCaret: column.sortCaret || defaultSortCaret,
    }))}
    classes="sheet-table"
    remote={{ sort: true }}
    pagination={false}
    rowClasses={rowClasses}
    defaultSorted={defaultSorted}
    sort={sort}
    onTableChange={onTableChange}
    {...(expandRow && { expandRow })}
    {...(rowEvents && { rowEvents })}
  />
);
